import { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import { ReactComponent as ScountAgentLogo } from 'components/assets/scount-agent-logo.svg';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import ChatInput from 'components/widgets/ScoutAgent/MainView/ChatInput';
import SuggestCorrectionFooter from 'components/widgets/SuggestCorrection/Footer';

const containerStyle = {
  flex: 1,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: 'padding_16',
};

const mainContentStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 'padding_32',
  maxWidth: '600px',
  margin: '0 auto',
};

const logoStyle = {
  marginBottom: 'padding_32',
};

const titleStyle = {
  marginBottom: 'padding_8',
  textAlign: 'center',
};

const descriptionStyle = {
  marginBottom: 'padding_48',
  textAlign: 'center',
  maxWidth: '480px',
};

const inputWrapperStyle = {
  width: '100%',
  maxWidth: '560px',
};

const TITLE = 'Get answers with Scout';

const DESCRIPTION = `Scout makes sense of construction data so you don't have to. Find, analyze, and simplify project data in seconds.`;

type EmptyStateProps = {
  onPromptSubmit: (arg0: string) => void;
};

const EmptyState = ({ onPromptSubmit }: EmptyStateProps) => {
  const [inputValue, setInputValue] = useState('');

  const onSubmit = () => {
    onPromptSubmit(inputValue);
  };

  return (
    <FlexColumn sx={containerStyle}>
      <Box sx={mainContentStyle}>
        <Box sx={logoStyle}>
          <ScountAgentLogo />
        </Box>
        <Text.Lead sx={titleStyle}>{TITLE}</Text.Lead>
        <Text.Large color={Colors.TextQuiet} sx={descriptionStyle}>
          {DESCRIPTION}
        </Text.Large>
        <Box sx={inputWrapperStyle}>
          <ChatInput value={inputValue} onChange={setInputValue} onSubmit={onSubmit} />
        </Box>
      </Box>
      <SuggestCorrectionFooter variant="inline" />
    </FlexColumn>
  );
};

export default EmptyState;
